import React from 'react';
import { Button } from 'react-bootstrap';
import { PermissionRequired } from '../../components';
import { Action, ListActions } from '../../components';
import { ActionFbos } from '../../constants/Constants';
import { ModalsAction } from '../../actions';
import { Activities } from '../../constants';

export default React.createClass({
  render(){
    return (
      <ListActions>
        <PermissionRequired requiredRoles={Activities.READ_FBOS} user={this.props.metadata.user}>
          <Action icon="search" to={'/fbos/' + this.props.rowData.id} />
        </PermissionRequired>
        <PermissionRequired requiredRoles={Activities.WRITE_FBOS} user={this.props.metadata.user}>
          <Action icon="edit" onClick={this.handleEditFboClick} />
          <Action icon="remove" onClick={this.handleDeleteFboClick} />
        </PermissionRequired>
      </ListActions>
    )
  },

  handleEditFboClick(){
    ModalsAction.showFboForm(this.props.metadata.fboFormModalId, this.props.rowData);
  },

  handleDeleteFboClick(){
    ModalsAction.show(this.props.metadata.fboDeleteDialogId, { id: this.props.rowData.id, name: this.props.rowData.name });
  }
});
